export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=47ee0ffa&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/faq/index.vue?vue&type=template&id=47ee0ffa&
// module id = 1084
// module chunks = 0